import React from 'react';
import duytan from "../images/Logos/duytan.png";
import rayat from "../images/Logos/rayat.jpg";
import ieee from "../images/Logos/ieee.jpg"
import springer from "../images/Logos/springer.png"
import sol from "../images/Logos/sol.png"


import './styles.css';
import NavBar from './Navbar';
import { Link } from 'react-router-dom';
const Header = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-around py-5 md:py-20 header-bg">
        <div className="w-full md:w-3/5 text-left text-white header-container">
          <p className="text-xl md:text-2xl font-semibold">
            26th – 28th November 2026
          </p>
          <h1 className="text-2xl md:text-3xl md:my-8 font-bold md:text-center">
            2nd International Conference on Computational Technologies for Research in Data Analytics (ICCTRDA 2026)            
          </h1>
          <h2 className="text-xl md:text-2xl font-bold md:text-center">Focus: Computational methods, algorithms, data analytics</h2>
          <h3 className="text-lg md:text-xl font-semibold mt-4 mb-6 text-center">
            ORGANISED BY <br/>
            {/* <span className='uppercase'>School of Open Learning, Delhi University, INDIA</span>
            <br />
            &amp; */}
            DUYTAN UNIVERSITY, VIETNAM.
            {/* <br />
            in association with <br/>RAYAT BAHRA UNIVERSITY,MOHALI
            <br /> */}
            <br />
            <marquee style={{color:'red'}}>All accepted papers will be published in Springer LNNS series indexed by Scopus, Ei, WoS etc.</marquee>
            <br />
            <br />
            <a className=" px-8 py-3 bg-blue-500 rounded-lg">
              <span className="text-xl md:text-2xl font-semibold">
                <Link to={"/registrations"}>Register Now</Link>
              </span>
            </a>
          </h3>
        </div>
        <div className="flex flex-row md:flex-col items-center justify-around md:justify-center">
          <img src={duytan} className="w-32 md:w-56" />
          {/* <img src={rayat} className="w-32 md:w-56 md:mb-20" /> */}
          {/* <img src={springer} className='w-32 md:w-56'/> */}
          {/* <img src={sol} className='w-32 md:w-56'/> */}
        </div>
      </div>
      <NavBar />
    </>
  );
}

export default Header